module.exports = __webpack_public_path__ + "img/visa-logo.7e37e1c5.svg";